import { useRouter } from "next/router";
import React from "react";

const CMSAlert = ({ headerJson }) => {
  const { locale } = useRouter();
  const activeData = headerJson?.find(
    (item) => item?.active && item?.key === "alert-msg"
  );

  return (
    <>
      {activeData && (
        <div
          dangerouslySetInnerHTML={{ __html: activeData?.[`html-${locale}`] }}
        ></div>
      )}
    </>
  );
};

export default CMSAlert;
